import React from 'react';
import { Box } from '@material-ui/core';

import TopBar from './components/TopBar';
import SignUpForm from './components/SignUpForm';
import { useIsDesktop } from 'components/utilities';

function SignUp({ history }){
	const isDesktop = useIsDesktop()

	return (
		<Box>
			<TopBar />
			<Box p={isDesktop ? 3 : 0}>
				<SignUpForm history={history} />
			</Box>
		</Box>
	);
}

export default SignUp;
